"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _buttonEvolutionStyles = _interopRequireDefault(require("./buttonEvolutionStyles"));
var _buttonStyles = _interopRequireDefault(require("./buttonStyles"));
function cov_2qz230ggzp() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/A.js";
  var hash = "fd394077e077d84ab607837f9aeb99c99b639db4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/A.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 10
        },
        end: {
          line: 14,
          column: 2
        }
      },
      "1": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 14
          }
        },
        loc: {
          start: {
            line: 10,
            column: 22
          },
          end: {
            line: 10,
            column: 35
          }
        },
        line: 10
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fd394077e077d84ab607837f9aeb99c99b639db4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qz230ggzp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2qz230ggzp();
var A = (cov_2qz230ggzp().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.a.attrs({
  className: function className(props) {
    cov_2qz230ggzp().f[0]++;
    cov_2qz230ggzp().s[1]++;
    return props.clsName;
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, _buttonStyles.default), _themeProvider.TicketShopTheme.EVOLUTION, _buttonEvolutionStyles.default)));
var _default = exports.default = A;